( function($){

	var Viewport = {};

	Viewport.documentWidth = function(){
	  var e = window, a = 'inner';
	  if (!('innerWidth' in window )) {
	    a = 'client';
	    e = document.documentElement || document.body;
	  }
	  return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	var nav = {};

	nav.addFill = function() {
		$( window ).scroll(function() {
			if ( Viewport.documentWidth().width > 767 ) {
			    var scroll = $( window ).scrollTop();

			    if ( scroll >= 20 ) {
					$( '.start' ).addClass( 'fill' );
				} else {
					$( '.start' ).removeClass( 'fill' );
				}
			} else {
				$( '.start' ).removeClass( 'fill' );
			}
		} );
	};

	nav.toggleAnimation = function(){
		currentScroll = 0;

		$( '.navbar-collapse' ).on( 'shown.bs.collapse', function(){
			currentScroll = $( window ).scrollTop();
			$( 'html,body' ).addClass( 'lock-position' );
		}).on( 'hide.bs.collapse', function(){
			$( '.navbar-toggle' ).removeClass( 'navbar-open' );
			$( 'html,body' ).removeClass( 'lock-position' );
			$( window ).scrollTop( currentScroll );
			$( '.x-close' ).hide();
			$( '.o-open' ).show();
			$( this ).css({ 'right': -Viewport.documentWidth().width });
			$( 'body' ).css({ 'left': '0' });
			setTimeout( function(){
				$( 'body' ).removeClass( 'animate' );
			}, 300 );
		}).on( 'show.bs.collapse', function(){
			$( '.navbar-toggle' ).addClass( 'navbar-open' );
			$( '.x-close' ).show();
			$( '.o-open' ).hide();
			$( this ).css({ 'right': '0' });
			$( 'body' ).addClass( 'animate' ).css({ 'left': -Viewport.documentWidth().width });
		});

	};
	
	nav.togggleDesktop = function() {
		if ( Viewport.documentWidth().width >= 767 ) {
			$( 'html,body' ).removeClass( 'lock-position' );
			$( 'body' ).removeAttr( 'style' );
			$( 'body' ).removeClass( 'animate' );
			$( '.navbar-collapse' ).removeClass( 'in' );
			$( '.navbar-collapse' ).removeAttr( 'style' );
			$( '.navbar-toggle' ).removeClass( 'navbar-open' );
			$( '.x-close' ).hide();
			$( '.o-open' ).show();
		}
	};
	
	//Init
	nav.toggleAnimation();
	nav.addFill();
	
	$(window).bind( 'resize', function() {
		nav.togggleDesktop();
	} ).trigger( 'resize' );

}) (jQuery);
